import axisAu from '../../assets/axis-au.svg';
import axisDevice from '../../assets/axis-device.svg';
import axisDs from '../../assets/axis-ds.svg';
import device2nhwNew from '../../assets/device-2nhw-new.svg';
import mobile from '../../assets/mobile.svg';
import person from '../../assets/person.svg';
import thirdParty from '../../assets/third-party.svg';
import unknownSvg from '../../assets/unknown.svg';

export const getSvgIcon = (type) => {
  /* eslint-disable quote-props */
  const generic = {
    'axis-au': axisAu,
    'axis-device': axisDevice,
    'axis-ds': axisDs,
    'device-2nhw-new': device2nhwNew,
    mobile: mobile,
    person: person,
    'third-party': thirdParty,
  };
  /* eslint-enable quote-props */

  const genericType = type ? type.split('.').slice(0, 2).join('.') : null;
  if (generic[genericType]) {
    return generic[genericType];
  }
  return unknownSvg;
};
